export type NavPage = 'dashboard' | 'athletes' | 'pathways' | 'huddle' | 'legacy' | 'leadership' | 'reports' | 'settings' | 'waitlist' | 'institutions' | 'insights' | 'mentors';

export interface AdminProfile {
  fullName: string | null;
  institutionType: string | null;
  institutionId: string | null;
  institutionName: string | null;
  isAdmin: boolean;
}

export const ARCHETYPE_COLORS: Record<string, string> = {
  Commander: '#014c8d',
  Architect:  '#bf1e2e',
  Catalyst:   '#0fa86d',
  Guardian:   '#6b46c1',
};

export const CAREER_STAGE_LABELS: Record<string, string> = {
  amateur:      'Amateur',
  professional: 'Professional',
  retiring:     'Retiring',
  retired:      'Retired',
};

export interface Profile {
  id: string;
  full_name: string | null;
  username: string | null;
  sport: string | null;
  position: string | null;
  sport_position: string | null;
  career_stage: string | null;
  athlete_archetype: string | null;
  assessment_status: string;
  subscription_tier: string | null;
  institution_id: string | null;
  institution_type: string | null;
  is_admin: boolean | null;
  updated_at: string | null;
  completed_at: string | null;
  translation_score: number | null;
  bio: string | null;
  linkedin_url: string | null;
  instagram_url: string | null;
  avatar_url: string | null;
  transition_analysis: any | null;
  last_analysis_at: string | null;
}

export interface Institution {
  id: string;
  name: string;
  type: string;
  contact_name: string | null;
  contact_email: string | null;
  country: string;
  state_province: string | null;
  athlete_count: number;
  license_tier: string | null;
  license_fee: number | null;
  license_start_date: string | null;
  license_end_date: string | null;
  max_athletes: number | null;
  currency: string;
  status: string;
  internal_notes: string | null;
  created_at: string;
}

export interface WaitlistEntry {
  id: number;
  created_at: string;
  email: string | null;
  role: string | null;
}

export interface HuddlePost {
  id: string;
  topic_id: string | null;
  title: string;
  subtitle: string | null;
  description: string | null;
  content: string | null;
  user_id: string | null;
  user_name: string;
  likes_count: number;
  created_at: string;
  parent_id: string | null;
}
